
  <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
    <h2 class="headline m-0" fxFlex="auto">View {{attribute.DisplayName}}</h2>

    <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-divider class="-mx-6 text-border"></mat-divider>
  <mat-dialog-content fxLayout="column">
    <div *ngIf="isLoader;else content1" fxLayout="row" fxLayoutAlign="space-around center">
      <mat-progress-spinner strokeWidth="4" diameter="60" mode="indeterminate" color="primary"></mat-progress-spinner>
    </div>
    <ng-template #content1>
      <div class="overflow-y-auto" fxFlex="auto">
        <ng-container *ngTemplateOutlet="recursiveList; context:{ tab: attribute.ComplexValue, attr: attribute.Attribute}"></ng-container>
        <ng-template #recursiveList let-tab="tab" let-attr="attr">
          <ng-container *ngIf="attr.AttributeType.DisplayType == 1; else displayTable">
            <ng-container *ngIf="tab[attr.Name]?.length > 0; else emptyLabel">
              <ng-container *ngFor="let data of tab[attr.Name]; let i = index;">
                <div class="border p-3 mt-3">
                  <div class="border-b-2" fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row">
                      <h2 class="title m-0 primary">{{i+1}}.</h2>
                      &nbsp;
                      <h3><b>{{attr.DisplayName}}</b></h3>
                    </div>
                  </div>
                  <div fxLayout="column" class="pt-1">
                    <ng-container *ngFor="let type of getAttributes(data._ComplexAttributes);">
                      <ng-container *ngIf="(!type.IsComplex && !type.IsList)">
                        <div fxFlex>
                          <span class="primary leading-normal">
                            {{type.DisplayName}}
                          </span>: 
                          <ng-container *ngIf="type.DisplayType == 2; else otherOutput">
                            <span class="flex-auto text-sm leading-normal font-semibold text-black">{{getSelectionData(data, type)}}</span>
                          </ng-container>
                          <ng-template #otherOutput>
                            <ng-container *ngIf="type.AttributeType.BaseType == 'file' || type.AttributeType.Name == 'Template File'; else showContent">
                              <ng-container *ngIf="data[type.Name] && data[type.Name] != ''; else naFile">
                                <span (click)="getFile(data[type.Name])" class="flex-auto text-sm text-primary underline cursor-pointer">Click to download</span>
                              </ng-container>
                              <ng-template #naFile>
                                <span class="flex-auto text-sm leading-normal font-semibold text-black">N/A</span>
                              </ng-template>
                            </ng-container>
                            <ng-template #showContent>
                              <span class="flex-auto text-sm leading-normal font-semibold text-black" *ngIf="type.DataUrl && type.DataUrl != ''; else basicLable">{{data['ddLable_'+type.Name] ? data['ddLable_'+type.Name]:  'N/A'}}</span>
                              <ng-template #basicLable>
                                <span class="flex-auto text-sm leading-normal font-semibold text-black">{{ (data[type.Name] != undefined && data[type.Name] != null)  ? data[type.Name] : 'N/A' }}</span>
                              </ng-template>
                            </ng-template>
                          </ng-template>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="type.IsList">
                        <div class="border p-3 mt-2 mb-2">
                          <div class="border-b-2 mb-2" fxLayout="row" fxLayoutAlign="space-between center">
                            <h4><b>{{type.DisplayName}}</b></h4>
                          </div>
                          <div fxLayout="column" class="pt-2">
                            <b *ngIf="!data[type.Name] || data[type.Name].length == 0">N/A</b>
                            <ul class="a pl-4">
                              <ng-container *ngIf="type.DisplayType == 2; else otherComplexList1">
                                <li class="flex-auto text-sm break-all leading-normal font-semibold text-black" *ngFor="let val of getSelectionData(data, type)">
                                  {{val}}
                                </li>
                              </ng-container>
                              <ng-template #otherComplexList1>
                                <li class="flex-auto text-sm leading-normal font-semibold text-black" *ngFor="let d of data[type.Name]">
                                  {{d}}
                                </li>
                              </ng-template>
                            </ul>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="type.IsComplex">
                        <ng-container *ngTemplateOutlet="recursiveList; context:{ tab: data, attr: type}"></ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #emptyLabel>
              <div class="border p-3 mt-2 mb-2">
                <div class="border-b-2 mb-2" fxLayout="row" fxLayoutAlign="space-between center">
                  <h4><b>{{attr.DisplayName}}</b></h4>
                </div>
                <div fxLayout="column" class="pt-2">
                  <b>N/A</b>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #displayTable>
            <div class="mt-2 mb-2">
              <elastic-complex-table-view
                [isGetComplexAttribute]="true"
                [data]="tab[attr.Name]"
                [displayName]="attr.DisplayName"
                [name]="attr.Name"
                [columns]="attr.AttributeType.AttributeTypes"
              >                               
              </elastic-complex-table-view>
            </div>
          </ng-template>
        </ng-template>
      </div>
    </ng-template>
  </mat-dialog-content>